// Where to go after signing in. A push notification or a bookmark can open a
// deep page (a task, an enquiry) while signed out; the Google round trip used
// to drop that and land on the dashboard. Kept in localStorage because the
// OAuth redirect reloads the app.
const KEY = "br_return_to";
const MAX_AGE_MS = 15 * 60 * 1000;

function isAppPath(path) {
  return typeof path === "string" && path.startsWith("/") && !path.startsWith("//")
    && !path.startsWith("/login") && path !== "/";
}

export function rememberReturnPath(path) {
  try {
    if (isAppPath(path)) localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch {}
}

export function takeReturnPath() {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    if (!raw) return null;
    const { path, at } = JSON.parse(raw);
    return isAppPath(path) && Date.now() - at < MAX_AGE_MS ? path : null;
  } catch {
    return null;
  }
}
